<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.inbound.dashboard.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inbound.dashboard.page_title_line_2") }}
      </h3>
    </div>

    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.movement.dashboard.table_title')"
            :value="ordersCount"
            font-size="xs"
            v-if="!shouldLoading"/>
            
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.dashboard.box_label_2')"
            :value="receptionTime"
            font-size="xs"
            v-if="!shouldLoading"
            valueColor="red"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.dashboard.box_label_3')"
            :value="maxReceptionTime"
            font-size="xs"
            valueColor="red"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1 bx-box-adjustable">
          <bx-value
            :label="$t('lang.inbound.dashboard.box_label_4')"
            :value="delayAvgReceptionTime"
            font-size="xs"
            valueColor="red"/>
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.dashboard.box_label_5')"
            :value="orderPerDay"
            font-size="xs"
            suffix="orders"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.dashboard.box_label_6')"
            :value="orderIncorrectPerDay"
            font-size="xs"
            valueColor="red"
          />
        </bx-box>
      </div>
      <skeleton-boxes progress-box :boxes="5" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <bx-box :title="$t('lang.common.historic')" no-padding :loading="shouldLoading"/>
        <section class="layout">
          <div class="grow1" style="max-width: 50%;">
              <v-select v-model="status" :items=filterStatus item-value="value" v-on:change="getData" 
                    :label="$t('lang.common.state')" outlined />
          </div>
          <div class="marginLeft">          
              <Printers :is-disabled="selectedRecords.length < 1" :selectedRecords="selectedRecords" @print="print"></Printers>
          </div>
          <div>
              <v-btn text dark class="mb-4" :disabled="this.filters.arrivalDate==null || this.filters.arrivalDate.date_start==null">
                  <v-avatar :style="{ backgroundColor: this.filters.arrivalDate==null || this.filters.arrivalDate.date_start==null    ? '#aaa' : '#27362F' }"
                    class="pa-2 cursor-pointer" @click="download">
                      <img src="@/assets/i/Icon-download-w.svg" />
                  </v-avatar>
              </v-btn>
          </div>
        </section>
     
        <bx-table v-if="!shouldLoading" 
          :data="data" 
          :columns="columns" 
          paginated backendPagination 
          :currentPage="page" 
          :perPage="itemsPerPage" 
          :total="ordersCount"
          @search="onSearch" 
          @update:currentPage="updatePage">

          <template slot-scope="props">

              <bx-table-column field="destination_status" centered>
                <bx-order-status :status="props.row.destination_status"></bx-order-status>
              </bx-table-column>
              <bx-table-column field="waiting_time" centered>
                  <strong :class="props.row.time_color">{{props.row.waiting_time}}</strong>
              </bx-table-column>
              <bx-table-column centered>
                  <router-link :to="`/inbound/order/${props.row.id.replaceAll('/','-')}/detail`"
                              class="bx-link bx-link-bold">{{ props.row.id }}
                  </router-link>
              </bx-table-column>
              <bx-table-column centered>{{props.row.delivery_note}}</bx-table-column>
              <bx-table-column centered>{{formatDate(props.row.arrival_date)}}</bx-table-column>
              <bx-table-column centered>{{props.row.item_count}}</bx-table-column>
              <bx-table-column centered>{{props.row.real_item_count}}</bx-table-column>
              <bx-table-column centered>
                  <router-link :to="`/inbound/order/${props.row.id}/boxes`" class="bx-link">
                                <b>{{ props.row.num_verified_boxes }}</b>/ {{ props.row.num_boxes }}
                  </router-link>
              </bx-table-column>
              <bx-table-column centered>
                <router-link :to="`/inbound/provider/${props.row.origin}/detail`"
                  class="bx-link bx-link-bold"> {{ props.row.provider_name }}
                </router-link>
              </bx-table-column>

              <bx-table-column>
                <img
                  @click="downloadFile(props.row.id)"
                  style="cursor: pointer"
                  src="@/assets/i/Icon-download.svg"
                />
              </bx-table-column>

              <bx-table-column centered class="align-items-start d-flex justify-center">
                <v-checkbox
                  class="shrink mr-0 mt-0 pt-0" color="#FF5800" hide-details
                  @change="onSelectRecord(props.row)" :value="props.row.id" v-model="selectedRows">
                </v-checkbox>
              </bx-table-column>
          </template>
        </bx-table>
        </div>
        <v-row class="d-flex d-sm-none">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="20"
            style="width: 100%">
            <v-list width="100%">
              <v-list-item
                two-line
                v-for="(item, index) in dataList"
                :key="index"
                class="green lighten-5 ma-2 rounded-lg"
                ripple
                :to="`/inbound/order/${item.id}/detail`"
              >
                <v-list-item-content>
                  <v-list-item-title><div>{{ item.id }}</div></v-list-item-title>
                  <v-list-item-subtitle>{{item.provider_name}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">{{formatDate(item.arrival_date)}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <div>
                    <img
                      v-if="item.destination_status === 2"
                      style="height: 20px; width: 20px"
                      src="@/assets/i/triangle-outline.svg"
                    />
                    <bx-tag v-if="item.destination_status == 3"
                      ><i class="fa fa-check green-icon"></i
                    ></bx-tag>
                  </div>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.real_item_count + "/" + item.item_count }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-caption">
                    {{ item.waiting_time }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-row>
        <skeleton-table :columns="13" v-if="shouldLoading" />
      </div>
    </div>
</template>
<script>

let filterStatus = [
  { value: null, text: "Todas" },
  { value: 0, text: "Sin verificar" },
  { value: 1, text: "En verificación" },
  { value: 2, text: "Verificadas con diferencias" },
  { value: 3, text: "Verificadas correctamente" },
];

import c from "../../colors";
import months from "../../months";
import BxTableColumn from "../../bx-components/BxTableColumn";
import moment from "moment/dist/moment";
import Printers from "@/components/Printers";
import common from "@/utils/common";
// import Download from '@/components/Download.vue'

var loading = false;
export default {
  name: "inbound-dashboard",
  mixins: [common],
  components: { BxTableColumn, Printers },
  data() {
    return {
      key: "inbound",
      selectedRows: [],
      selectedRecords: [],
      clean_array: [],
      shouldLoading: true,
      columns: [],
      dialog: false,
      data: [],
      dataList: [],
      filterStatus: filterStatus,
      status: null,
      ordersCount: "",
      receptionTime: "",
      maxReceptionTime: "",
      delayAvgReceptionTime: "",
      orderPerDay: "",
      orderIncorrectPerDay: "",
      inboundData: {},
      outboundData: {},
      evolutionData: {},
      stock: {},
      API_BASE: process.env.VUE_APP_API_BASE,
      reloadInterval: null,
      locationId: null,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1,
      filters: {
        origin__name__contains: null,
        arrival_date__contains: null,
        arrival_date__gte: null,
        arrival_date__lte: null,
      },
    };
  },
  computed: {
    role: function () {
      return this.$store.state.user.role;
    },
    location() {
      return localStorage.getItem("location");
    },
  },
  methods: {
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.ordersCount &&
        this.isMobile
      ) {
        this.page++;
        this.getData();
      }
    },
    deleteOrders() {
      this.selectedRows.forEach((x) => {
        let foundIndex = this.data.findIndex((o) => o.id === x);
        this.data.splice(foundIndex, 1);
        this.$api.porders.deleteOrder(x);
      });
      this.selectedRows = [];
    },
    formatDate(date) {
      return date
        ? moment(date).format("DD/ MM/ YYYY, h:mm a")
        : this.$t("lang.messages.no_date_available");
    },
    async downloadFile(id) {
      try {
        await this.$api.porders.download(id);
      } catch (error) {
        console.log(error);
      }
    },
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      switch (field) {
        case "id":
          this.filters.orderCode = value;
          this.getData();
          break;
        case "origin":
          this.filters.origin = value;
          this.getData();
          break;
        case "arrivalDate":
          this.filters.arrivalDate = value;
          this.getData();
          break;
      }
    },
    async print(printer) {
      this.selectedRows.forEach(async (value) => {
        await this.$api.porders.print(value, printer);
      });
    },

    changeStatusItem: function (id, status) {
      this.$api.porders
        .sync(id, status)
        .then(() => {
          this.$forceUpdate();
          location.reload();
        })
        .catch((error) => {
          const errorKey = Object.keys(error.response.data)[0];
          this.$refs["errorNotification"].showNotification(
            error.response.data[errorKey][0]
          );
        });
    },
    updatePage(p) {
      // window.location.href = '/inbound'
      this.page = p;
      this.getData();
    },
    onSelectRecord(item) {
      let foundIndex = this.selectedRecords.findIndex((x) => x.id === item.id);
      if (foundIndex === -1) {
        this.selectedRecords.push(item);
      } else {
        this.selectedRecords.splice(foundIndex, 1);
      }
    },
    async getOrders(locationId) {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        // Load orders
        const orders = await this.$api.porders.list(locationId, {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
          order_code__contains: this.filters.orderCode,
          origin__name__contains: this.filters.origin,
          // arrival_date__contains: this.filters.arrivalDate
          arrival_date__gte:
            this.filters.arrivalDate && this.filters.arrivalDate.date_start,
          arrival_date__lte:
            this.filters.arrivalDate && this.filters.arrivalDate.date_end,
          destination_status: this.status,
          order_by: "-id"

        });

        this.ordersCount = orders.count;
        let data = (this.data = orders.results.map((item) => {
          let isAfter = moment().isAfter(item.estimated_arrival_date);

          return {
            id: item.order_code,
            origin_status: item.origin_status,
            destination_status: item.destination_status,
            waiting_time: item.waiting_time,
            delivery_note: item.delivery_note,
            item_count: item.item_count,
            real_item_count: item.real_item_count,
            num_boxes: item.num_boxes,
            num_verified_boxes: item.num_verified_boxes,
            creation_date: item.creation_date,
            estimated_arrival_date: item.estimated_arrival_date,
            arrival_date: item.arrival_date,
            origin: item.origin,
            provider_name: item.provider_name,
            time_color: isAfter ? "bx-text-red" : "bx-text-black",
          };
        }));

        if (this.isMobile) {
          this.dataList = this.dataList.concat(data);
        }

        this.columns = [
          {
            field: "destination_status",
            label: this.$t("lang.inbound.dashboard.table_field_1"),
            centered: true,
            width: 50,
          },
          {
            field: "waiting_time",
            label: this.$t("lang.inbound.dashboard.table_field_2"),
            centered: true,
            width: 100,
          },
          {
            field: "id",
            label: this.$t("lang.inbound.dashboard.table_field_3"),
            filter: {
              placeholder: this.$t(
                "lang.inbound.dashboard.table_field_placeholder_3"
              ),
              value: this.filters.orderCode,
            },
            centered: true,
          },
          {
            field: "delivery_note",
            label: this.$t("lang.inbound.dashboard.table_field_12"),
            centered: true,
            width: 50,
          },
          {
            field: "arrivalDate",
            label: this.$t("lang.inbound.dashboard.table_field_4"),
            filter: {
              placeholder: this.$t(
                "lang.inbound.dashboard.table_field_placeholder_4"
              ),
              value: this.filters.arrivalDate,
              isdateRange: true,
            },
            centered: true,
          },
          {
            field: "item_count",
            label: this.$t("lang.inbound.dashboard.table_field_5"),
            centered: true,
          },
          {
            field: "real_item_count",
            label: this.$t("lang.inbound.dashboard.table_field_6"),
            centered: true,
          },
          {
            field: "num_boxes",
            label: this.$t("lang.inbound.dashboard.table_field_7"),
            centered: true,
          },
          {
            field: "origin",
            label: this.$t("lang.inbound.dashboard.table_field_8"),
            filter: {
              placeholder: this.$t(
                "lang.inbound.dashboard.table_field_placeholder_8"
              ),
              value: this.filters.origin,
              isdate: false,
            },
            centered: true,
          },
          {
            field: "diferences",
            label: this.$t("lang.inbound.dashboard.table_field_13"),
            centered: true,
          },
          {
            field: "action",
            label: this.$t("lang.inbound.dashboard.table_field_11"),
            centered: true,
          },
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.selectedRecords = [];
        this.selectedRows = [];
      }
    },
    async getData() {
      try {
        // Load stats
        if (!loading) {
          loading = true;
          let location = localStorage.getItem("location");
          this.locationId = localStorage.getItem("location_id");
          if (!location) {
            try {
              let firstLocation = await this.$api.location.search("", {
                limit: 1,
                offset: 0,
                orderBy: "id",
              });
              location = firstLocation.results[0].description;
              this.locationId = firstLocation.results[0].id;
            } catch (error) {
              console.log(error);
            }
          }

          const inboundStats = await this.$api.location.inboundStats(
            this.locationId
          );
          this.delayAvgReceptionTime = inboundStats.average_delay;
          this.orderPerDay = inboundStats.daily_orders;
          var recpSplitted = inboundStats.reception_time.split(",");
          this.receptionTime = recpSplitted[0];
          var maxSplitted = inboundStats.max_time.split(",");
          this.maxReceptionTime = maxSplitted[0];
          this.orderIncorrectPerDay = inboundStats.incorrect_daily_orders;

          // Load orders
          await this.getOrders(this.locationId);

          this.stock = {
            total: inboundStats.total_orders_for_today,
            left: {
              value:
                inboundStats.total_orders_for_today -
                inboundStats.total_pending_orders_for_today,
              label: this.$t("lang.inbound.dashboard.box_left_1"),
              icon: require("@/assets/i/check.png"),
            },
            right: {
              value: inboundStats.total_pending_orders_for_today,
              label: this.$t("lang.inbound.dashboard.box_right_1"),
              icon: require("@/assets/i/ordersTime.png"),
            },
          };

          // Evolution data
          this.evolutionData = {
            labels: months,
            datasets: [
              {
                label: this.$t("lang.inbound.dashboard.line_graph_label_1"),
                backgroundColor: c.getRGBA(c.lime, 0.6),
                borderColor: c.lime,

                data: inboundStats.correctly_received_porders,
              },
              {
                label: this.$t("lang.inbound.dashboard.line_graph_label_2"),
                backgroundColor: c.getRGBA(c.red, 0.6),
                borderColor: c.red,
                data: inboundStats.incorrectly_received_porders,
              },
            ],
          };
          loading = false;
          this.shouldLoading = false;
          this.selectedRecords = [];
          this.selectedRows = [];
        }
      } catch (error) {
        // console.log(error)
      }
    },
    formattedDate(date) {
      return date ? moment(date.toString()).format("YYYY-MM-DD") : "";
    },
    async download() {
      const fromDate =
        this.filters.arrivalDate &&
        this.formattedDate(this.filters.arrivalDate.date_start) + " 00:00:00";
      const toDate =
        this.filters.arrivalDate &&
        this.formattedDate(this.filters.arrivalDate.date_end) + " 23:59:59";
      const locationId = this.locationId;
      await this.$api.printer.downloadPrinter(locationId, fromDate, toDate);
    },
  },
  mounted() {
    this.filters.orderCode = this.$session.get(this.key + "id");
    this.filters.origin = this.$session.get(this.key + "origin");
    this.filters.arrivalDate = this.$session.get(this.key + "arrivalDate");
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  },
};
</script>

<style scoped>
@media screen and (max-width: 578px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 89px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}
</style>

<style scoped>
@media screen and (max-width: 414px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 89px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 0px !important;
  }
}

@media screen and (max-width: 411px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 79px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 0px !important;
  }
}
</style>
